// extracted by mini-css-extract-plugin
export var childrenContainer = "_c3-0";
export var virtualScrollArea = "_c3-1";